const restaurantProductImpressionCategories = [
    'loggedInAs',
    'URLContains',
    'integrationsChoice',
    'integrationsLanding',
] as const;
type RestaurantProductImpressionCategory =
    typeof restaurantProductImpressionCategories[number];
type RestaurantProductImpressionData = Partial<
    Record<RestaurantProductImpressionCategory, string>
>;
const products = ['retail', 'restaurant', 'ecommerce', 'golf'] as const;
type Product = typeof products[number];
type BusinessTypeData = Partial<Record<Product, string>>;
type LsVisitorCookie = {
    restaurantProductImpressions?: RestaurantProductImpressionData;
    dynamicPagesCookieData?: Record<string, unknown>;
    businessType?: BusinessTypeData;
};

export { restaurantProductImpressionCategories, products };
export type {
    RestaurantProductImpressionCategory,
    RestaurantProductImpressionData,
    LsVisitorCookie,
    Product,
};
